import axios from 'axios';

const API_BASE_URL = `${import.meta.env.VITE_API_URL ?? ''}/api`;

interface Account {
  id: string;
  name: string;
  industry?: string;
  website?: string;
  phone?: string;
  address?: string;
}

interface GetAccountsParams {
  limit?: number;
  offset?: number;
  search?: string;
}

interface GetAccountsResponse {
  data: Account[];
  total: number;
}

export const accountsService = {
  async getAccounts(params?: GetAccountsParams): Promise<GetAccountsResponse> {
    try {
      const response = await axios.get(`${API_BASE_URL}/accounts`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching accounts:', error);
      throw error;
    }
  },

  async getAccountById(id: string): Promise<Account> {
    try {
      const response = await axios.get(`${API_BASE_URL}/accounts/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching account:', error);
      throw error;
    }
  },

  async createAccount(accountData: Partial<Account>): Promise<Account> {
    try {
      const response = await axios.post(`${API_BASE_URL}/accounts`, accountData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating account:', error);
      throw error;
    }
  },

  async updateAccount(id: string, accountData: Partial<Account>): Promise<Account> {
    try {
      const response = await axios.put(`${API_BASE_URL}/accounts/${id}`, accountData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating account:', error);
      throw error;
    }
  },

  async deleteAccount(id: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/accounts/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      console.error('Error deleting account:', error);
      throw error;
    }
  },
};
